export default {
  "nav.home": "Home",
  "nav.categories": "Categories",
  "nav.articles": "Guides",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.homeBtn": "Home",

  "hero.badge": "Independent shopping resource",
  "hero.title": "USFans Spreadsheet — Find Products, Sellers & Shopping Resources Faster",
  "hero.subtitle": "Explore the USFans Spreadsheet, discover products and sellers, compare useful resources, and learn about shipping, warehouse, QC and shopping safety.",
  "hero.ctaPrimary": "Explore USFans Spreadsheet",
  "hero.ctaSecondary": "Browse Guides",
  "hero.searchPlaceholder": "Search USFans Spreadsheet, products, sellers or categories...",

  "cta.usfans": "usfans spreadsheet",
  "cta.buynow": "buy it now",

  "categories.dropdownLabel": "Choose a category",
  "categories.title": "Browse by Category",
  "categories.subtitle": "Pick a category below to jump straight to the matching products on the main store.",

  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  "articles.title": "Latest Guides & Resources",
  "articles.subtitle": "Original guides to help you shop smarter with the USFans Spreadsheet.",
  "articles.readMore": "Read article",
  "articles.minRead": "min read",

  "content.title": "What Is the USFans Spreadsheet?",
  "content.p1": "The USFans Spreadsheet is a handy reference that gathers product categories and seller links into one clean place. Instead of hunting across the web, you can open a category and go straight to what you are looking for — from shoes and hoodies to bags, belts, and fragrances.",
  "content.p2": "Each category points to a dedicated page on the main store, so you always land where the products actually are. This makes browsing faster and keeps everything organized by type.",
  "content.cta": "Open the USFans Spreadsheet",

  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers about how the USFans Spreadsheet works.",

  "safety.title": "Shop with Confidence",
  "safety.text": "This is an independent informational resource. Always verify product details, prices, and shipping directly on the store before you buy.",
  "safety.disclaimer": "USFansLink.club is an independent informational resource and should not be presented as the official USFans website unless an official relationship has been verified.",

  "footer.disclaimer": "USFansLink.club is an independent informational resource and is not affiliated with or endorsed by any store mentioned. All external links open in a new tab.",
  "footer.rights": "All rights reserved.",

  "article.back": "Back to home",
  "article.updated": "Last updated",
  "article.pros": "Pros",
  "article.cons": "Cons",
  "article.faq": "FAQ",
  "article.related": "Related Guides",
  "article.ctaTitle": "Ready to explore?",
  "article.ctaText": "Head to the USFans Spreadsheet and start browsing products and sellers.",
  "article.ctaButton": "Open USFans Spreadsheet",
};